import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'
const Footer = (
  <View style={styles.footerContainer} fixed>
    <Text style={styles.footerText}>
      CONFIDENTIAL: The contents of this document is confidential and intended for the use by the individual or entity
      to whom this license was purchased by. If you are not the intended individual or entity, you are notified that
      disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly
      prohibited.
    </Text>
  </View>
)
export default Footer
